(() => {
  if (window.sorvenoInquiryContext) return;
  window.sorvenoInquiryContext = true;

  const parse = (value, fallback) => {
    try { return JSON.parse(value); } catch { return fallback; }
  };
  const productPath = (value) => {
    try {
      if (!value || !value.startsWith('/') || value.startsWith('//')) return null;
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname) ? url : null;
    } catch { return null; }
  };

  function syncLink(link) {
    const url = new URL(link.href, location.origin);
    const path = productPath(url.searchParams.get('ref'));
    const panel = link.closest('[id^="sor-dp-v2-"]');
    if (!path) return;
    const productId = panel?.id.slice('sor-dp-v2-'.length);
    const root = link.closest('[data-sor-inquiry-product]') || Array.from(document.querySelectorAll('[data-sor-inquiry-product]'))
      .find((node) => node.dataset.sorInquiryProduct === productId && node.querySelector('variant-picker[form-id^="product-form-main-"]'));
    if (!root) return;
    const picker = root.querySelector('variant-picker[form-id^="product-form-main-"]');
    const options = parse(root.querySelector('[data-sor-inquiry-options]')?.textContent, []);
    const groups = Array.from(picker.querySelectorAll('.product-form__option-selector'));
    const configuration = options.flatMap((option, index) => {
      const group = groups[index];
      if (group?.hasAttribute('data-sor-inquiry-exclude')) return [];
      const selected = group?.querySelector('input:checked, select, input[type="hidden"][data-option-position]');
      const value = option.values.find((item) => item.id === selected?.value);
      return value ? [{ name: option.name, value: value.label }] : [];
    });
    const variant = picker.selectedVariant || parse(picker.querySelector('[data-variant]')?.textContent, null);
    const matches = variant?.id && configuration.length === options.length &&
      configuration.every((item, index) => item.value === variant.options?.[index]);
    path.searchParams.delete('variant');
    path.searchParams.delete('preview_theme_id');
    url.searchParams.delete('variant');
    if (matches) {
      path.searchParams.set('variant', variant.id);
      url.searchParams.set('variant', variant.id);
    }
    url.searchParams.set('ref', path.pathname + path.search);
    if (configuration.length) url.searchParams.set('configuration', JSON.stringify(configuration));
    else url.searchParams.delete('configuration');
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
    link.href = url.pathname + url.search + url.hash;
  }

  function initContact() {
    const params = new URLSearchParams(location.search);
    const product = params.get('product')?.trim().slice(0, 300);
    if (!product) return;
    const raw = parse((params.get('configuration') || '').slice(0, 2000), []);
    const configuration = Array.isArray(raw) ? raw.slice(0, 3).filter((item) =>
      typeof item?.name === 'string' && typeof item?.value === 'string' && item.name.trim() && item.value.trim()
    ).map((item) => ({ name: item.name.trim().slice(0, 80), value: item.value.trim().slice(0, 160) })) : [];
    const path = productPath(params.get('ref'));
    const variant = params.get('variant');
    if (path) {
      path.searchParams.delete('preview_theme_id');
      if (variant && /^\d+$/.test(variant)) path.searchParams.set('variant', variant);
    }
    document.querySelectorAll('form.sor-contact__form').forEach((form) => {
      if (form.dataset.sorContextReady) return;
      form.dataset.sorContextReady = 'true';
      const field = (name, value) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `contact[${name}]`;
        input.value = value;
        form.append(input);
      };
      field('Product of Interest', product);
      const lines = [`Product of interest: ${product}`];
      configuration.forEach((item) => lines.push(`${item.name}: ${item.value}`));
      if (configuration.length) field('Selected Configuration', configuration.map((item) => `${item.name}: ${item.value}`).join('\n'));
      if (path) {
        lines.push(`Product link: ${path.href}`);
        field('Product Link', path.href);
        const id = path.searchParams.get('variant');
        if (id && /^\d+$/.test(id)) field('Variant ID', id);
      }
      const textarea = form.querySelector('textarea[name="contact[body]"]');
      if (textarea && !textarea.value.trim()) textarea.value = lines.join('\n') + '\n\nProject requirements:\n';
    });
  }

  const inquirySelector = '[data-sor-product-quote], [id^="sor-dp-v2-"] a[href*="product="][href*="ref="]';
  const links = () => document.querySelectorAll(inquirySelector);
  const init = () => { links().forEach(syncLink); initContact(); };
  ['pointerdown', 'focusin', 'click', 'auxclick', 'contextmenu'].forEach((name) => {
    document.addEventListener(name, (event) => {
      const link = event.target.closest?.(inquirySelector);
      if (link) syncLink(link);
    }, true);
  });
  document.addEventListener('variant:changed', () => links().forEach(syncLink));
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
